module.exports = __webpack_public_path__ + "img/partyBanner.5a9807ed.png";